import React from 'react'
import { landCoverMetadata } from '../config/landCover'

const Hover = props => {
  const { data } = props
  console.log('hover')

  console.log(data)
  if (!data.LC_class) {
    return null
  }
  try {
    const item = landCoverMetadata.find(item => item.value === data.LC_class)

    return (
      <div>{item.label}</div>
    )
  } catch(error) {
    return null
  }
}

export default Hover



// WEBPACK FOOTER //
// ./src/components/Hover.js